import Button from 'components/Button'
import Icon from 'components/Icon'
import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { Table } from 'react-bootstrap'
import styled from 'styled-components'

const Wrapper = styled.div`
  // margin: 0 -12px;
`

const assetTypes = {
  shipment_customsdocs: 'Zolldokument',
  shipment_invoicedocument: 'Handelsrechnung',
}

const DocumentTable = (props) => {
  const { order } = props

  const { invoiceDocument = [], additionalCustomsDocs = [] } = order

  const items = useMemo(
    () =>
      lodash.concat(invoiceDocument, additionalCustomsDocs, [
        // {
        //   assetType: "shipment_customsdocs",
        //   extension: "pdf",
        //   name: "Handelsrechnung R1231"
        // }
      ]),
    [invoiceDocument, additionalCustomsDocs],
  )

  if (lodash.isEmpty(items)) {
    return null
  }

  return (
    <Wrapper className="pb-2">
      <h4 className="px-1">
        {i18n.t('uploaded_documents', 'Hochgeladene Dokumente')}
      </h4>
      <Table size="sm" astriped responsive hover style={{ marginBottom: '0' }}>
        <thead>
          <tr>
            <th>Dokumentname</th>
            <th>Typ</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {lodash.map(items, ({ name, assetType, extension, key }) => (
            <tr>
              <td>
                <Icon icon={`fas fa-file-${extension}`} /> {name}
              </td>
              <td style={{ whiteSpace: 'nowrap' }} width="1%">
                {lodash.get(assetTypes, assetType)}
              </td>
              <td style={{ whiteSpace: 'nowrap' }} width="1%">
                <Button
                  textOnly
                  icon="fas fa-download"
                  hasStyle
                  primary
                  href={`/auftrag/api/orderlisting/document/${key}`}
                  target="_blank"
                >
                  Herunterladen
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Wrapper>
  )
}

export default DocumentTable
